<template>
  <FiltersChip
    :text="filter.text"
    :value="displayValue"
    @clear="clear"
  >
    <template #form="{ hide }">
      <v-form
        v-model="formValid"
        @submit.prevent="() => submit(hide)"
      >
        <v-autocomplete
          v-model="localValue"
          :items="filter.choices"
          :label="`${filter.text} values`"
          :menu-props="{ 'offset-y': true }"
          :multiple="filter.multiple"
          chips
        />
        <v-btn
          class="mt-2"
          color="primary"
          type="submit"
          small
          :disabled="!formValid"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Apply
        </v-btn>
        <v-btn
          class="ml-2 mt-2"
          small
          @click="hide"
        >
          <v-icon
            left
            small
          >
            mdi-cancel
          </v-icon>
          Cancel
        </v-btn>
      </v-form>
    </template>
  </FiltersChip>
</template>

<script>
import FiltersChip from './FiltersChip.vue';

export default {
  name: 'CaseActivityFiltersSelect',
  components: {
    FiltersChip,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.filter.multiple ? [] : null,
      displayValue: '',
      formValid: false,
    };
  },
  watch: {
    values(val) {
      if (!val[this.filter.name]) {
        this.localValue = this.filter.multiple ? [] : null;
        this.setDisplayValue();
      }
    },
    filter: {
      handler() {
        this.setDisplayValue(); // filter.choices might come from a request with some delay
      },
      deep: true,
    },
  },
  created() {
    this.localValue = this.values[this.filter.name] || (this.filter.multiple ? [] : null);
    this.setDisplayValue();
  },
  methods: {
    submit(hideCallback) {
      this.setDisplayValue();
      this.$emit('apply', { [this.filter.name]: this.localValue });
      hideCallback();
    },
    clear() {
      this.localValue = this.filter.multiple ? [] : null;
      this.setDisplayValue();
      this.$emit('apply', { [this.filter.name]: undefined });
    },
    setDisplayValue() {
      const selectedValues = this.filter.multiple ? this.localValue : [this.localValue];
      this.displayValue = this.filter.choices.filter(
        (c) => selectedValues.includes(c.value),
      ).map((c) => c.text).join(', ');
    },
  },
};
</script>
